import { Dispatch } from 'redux';
import * as actions from './actionCatalog';
import * as http from '../http';
import { AutoPrintRule } from 'reducers/autoPrintRulesReducer';

const regularGetAutoPrintRules = (dispatch: Dispatch) => http.get<AutoPrintRule[]>(actions.GET_AUTO_PRINT_RULES, dispatch);
export const getAutoPrintRules = () => regularGetAutoPrintRules;
